module.exports = __webpack_public_path__ + "电商企业.png?0715af015ef09e8b57964971ad08b63a";


//////////////////
// WEBPACK FOOTER
// ./static/assets/电商企业.png
// module id = 488
// module chunks = 0